import React from 'react';
import { Modal } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotate } from '@fortawesome/free-solid-svg-icons';
import { useConnectionErrorModalStore } from '@sharpana/shared/stores/connectionErrorModalStore';
import { css } from '@emotion/css';

const modalStyles = {
  content: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.5rem 1rem;
    text-align: center;
    
    @media (min-width: 768px) {
      padding: 2rem;
    }
  `,
  message: css`
    font-size: 1.125rem;
    margin-bottom: 1.5rem;
    line-height: 1.5;
    color: #e0e0e0;
    max-width: 90%;
    
    @media (min-width: 768px) {
      font-size: 1.25rem;
      max-width: 100%;
    }
  `,
  button: css`
    background: linear-gradient(90deg, #6a11cb 0%, #2575fc 100%);
    border: none;
    border-radius: 8px;
    color: white;
    font-weight: 600;
    font-size: 1rem;
    padding: 0.75rem 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 4px 12px rgba(37, 117, 252, 0.3);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(37, 117, 252, 0.4);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(37, 117, 252, 0.3);
    }
  `,
  icon: css`
    animation: spin 1.5s linear infinite;
    animation-play-state: paused;
    
    @keyframes spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
  `
};

export const ConnectionErrorModal: React.FC = () => {
  const { isVisible, hide } = useConnectionErrorModalStore();

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Modal
      title={null}
      open={isVisible}
      onCancel={hide}
      footer={null}
      centered
      maskClosable={false}
      closable={true}
      className={css`
        .ant-modal-content {
          background-color: #1f1f1f;
          border-radius: 12px;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
        }
        
        .ant-modal-body {
          padding: 0;
        }
        
        .ant-modal-close {
          color: #999;
          
          &:hover {
            color: #fff;
          }
        }
      `}
      width={340}
    >
      <div className={modalStyles.content}>
        <h3 className={css`
          color: #fff;
          font-size: 1.5rem;
          margin-bottom: 0.75rem;
          font-weight: 600;
        `}>Connection Error</h3>
        <p className={modalStyles.message}>
          Connection error, please refresh and try again!
        </p>
        <button 
          onClick={handleReload}
          className={modalStyles.button}
        >
          <FontAwesomeIcon 
            icon={faRotate} 
            className={css`
              ${modalStyles.icon}
              &:hover {
                animation-play-state: running;
              }
            `} 
          />
          Reload Page
        </button>
      </div>
    </Modal>
  );
};

export default ConnectionErrorModal;
